/** */
export const STATUS_LABELS = {
  pending_review: 'Pending review',
  regenerating: 'Regenerating',
  approved: 'Approved',
  published: 'Published',
  ready: 'Ready to post',
  generation_failed: 'Generation failed',
  needs_manual_intervention: 'Needs attention'
};

export const STATUS_CLASS = {
  pending_review: 'statusPending',
  regenerating: 'statusRegenerating',
  approved: 'statusApproved',
  published: 'statusPublished',
  ready: 'statusReady',
  generation_failed: 'statusFailed',
  needs_manual_intervention: 'statusAttention'
};

export const AGENT_TYPE_LABELS = { email: 'Email', social: 'Social', whatsapp: 'WhatsApp' };

export const SOCIAL_FORMAT_LABELS = {
  carousel: 'Carousel',
  quote_card: 'Quote card',
  did_you_know: 'Did you know',
  poll: 'Poll',
  talking_head_script: 'Talking head script'
};

export const READ_ONLY_STATUSES = ['published', 'ready'];

export const resolveJobVersion = (job = {}) => {
  const { versions = [], current_version } = job;
  return versions.find((version) => version.version === current_version) || null;
};

export const resolveJobOutput = (job = {}) => {
  if (job.edited_output) return job.edited_output;
  return resolveJobVersion(job)?.output || null;
};

export const resolveLatestRejection = (job = {}) => {
  const { versions = [] } = job;
  return [...versions].reverse().find((version) => !!version.rejection_comment) || null;
};

export const formatDateTime = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
